import React, { useEffect } from "react";
import { LiaTimesSolid } from "react-icons/lia";
import {AccordionModalStyled} from "../../../styled/Accordion";

const MainModal = ({ isOpen, onClose, children, width, height, zIndex }) => {
    // 🔒 Lock background scroll when modal is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <AccordionModalStyled className="BubblePopIn" width={width} height={height} onClick={onClose} zIndex={zIndex}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="cancel">
                    <LiaTimesSolid color="#5fbec5" onClick={onClose} />
                </div>
                <div className="modal-body">
                    {children}
                </div>
            </div>
        </AccordionModalStyled>
    );
};

export default MainModal;